import React from 'react'
import { HelmetProvider } from 'react-helmet-async'

import './App.css'
import AppRouter from './routers/AppRouter'
import MeasureDataProvider from './contexts/MeasureDataProvider'
import AppProvider from './contexts/AppProvider'
import CustomToaster from './components/CustomToaster'
import ReactQueryProvider from './contexts/ReactQueryProvider'
import MuiCustomThemeProvider from './contexts/MuiCustomThemeProvider'
import GA4Provider from './contexts/GA4Provider'
import SentryProvider from './contexts/SentryProvider'


const App: React.FC = () => {
  return (
    <div className="App">
      <SentryProvider>
        <GA4Provider>
          <HelmetProvider>
            <MeasureDataProvider>
              <AppProvider>
                <ReactQueryProvider>
                  <MuiCustomThemeProvider>
                    <AppRouter/>
                    <CustomToaster />
                  </MuiCustomThemeProvider>
                </ReactQueryProvider>
              </AppProvider>
            </MeasureDataProvider>
          </HelmetProvider>
        </GA4Provider>
      </SentryProvider>
    </div>
  )
}

export default App
